<div class="container my-3">
  <div class="card-header py-3">
    <h1 class="text-gray-800" style="display: inline-block">Edit Warranty</h1>
    <button
      class="btn custom-buttons-btn m-2" 
      style="float: right"
      *ngIf="WarrantyDetails && plantDetails"
      [routerLink]="[
        '/component',
        'trains',
        'edit',
        WarrantyDetails.TrainId,
        'warrantiesgraph'
      ]"
      [queryParams]="{
        trainId: WarrantyDetails.TrainId,
        plantId: WarrantyDetails.PlantId,
        plantName: plantDetails.Name,
        warrantyId: WarrantyDetails.Id
      }"
    >
      Graph
    </button>
  </div>
  <form #form="ngForm" (ngSubmit)="updatewarranty()">
    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="name" class="form-label">Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="name"
          name="name"
          [(ngModel)]="WarrantyDetails.Name"
          autocomplete="on"
        />
      </div>
    </div>
    <!-- Commented on 12th may 2026 for the breadcrumb changes -->
<!-- 
    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="name" class="form-label">Plant:</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          name="plantid"
          (change)="getSelectedId($event)"
          [(ngModel)]="WarrantyDetails.PlantId"
        >
          <option
            *ngFor="let plant of plants"
            [value]="plant.Id"
            [selected]="plant.Id === WarrantyDetails.PlantId"
          >
            {{ plant.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="train" class="form-label">Train:</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          name="trainid"
          (change)="getSelectedTrain($event)"
          [(ngModel)]="WarrantyDetails.TrainId"
        >
          <option
            *ngFor="let train of allTrainList"
            [value]="train.Id"
            [selected]="train.Id === WarrantyDetails.TrainId"
          >
            {{ train.Name }}
          </option>
        </select>
      </div>
    </div> -->

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="stage" class="form-label">Stage:</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          name="sategid"
          [(ngModel)]="WarrantyDetails.Stage"
        >
          <option
            *ngFor="let stages of stage"
            [value]="stages.Id"
            [selected]="stages.Id === WarrantyDetails.Stage"
          >
            {{ stages.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="type" class="form-label">Warranty Type:</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          name="type"
          [(ngModel)]="WarrantyDetails.Type"
        >
          <option
            *ngFor="let Wt of Wtypes"
            [value]="Wt.Id"
            [selected]="Wt.Id === WarrantyDetails.Type"
          >
            {{ Wt.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="maximunfeedpress" class="form-label"
          >Maximum Feed Pressure</label
        >
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="maximunfeedpress"
          name="maximunfeedpress"
          [(ngModel)]="WarrantyDetails.MaxPermTds"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="mintemp" class="form-label">Minimum Temperature:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="mintemp"
          name="mintemp"
          [(ngModel)]="WarrantyDetails.MinTemp"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="maxtemp" class="form-label">Maximum Temperature:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="maxtemp"
          name="maxtemp"
          [(ngModel)]="WarrantyDetails.MaxTemp"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="minFeedTds" class="form-label">Minimum Feed TDS:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="minFeedTds"
          name="minFeedTds"
          [(ngModel)]="WarrantyDetails.MinFeedTds"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="MaxFeedTds" class="form-label">Maximum Feed TDS:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="MaxFeedTds"
          name="MaxFeedTds"
          [(ngModel)]="WarrantyDetails.MaxFeedTds"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="MinPermFlow" class="form-label">Minimum Perm Flow:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="MinPermFlow"
          name="MinPermFlow"
          [(ngModel)]="WarrantyDetails.MinPermFlow"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="MinPermFlow" class="form-label">Maximum Perm Flow:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="MaxPermFlow"
          name="MaxPermFlow"
          [(ngModel)]="WarrantyDetails.MaxPermFlow"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: left">
        <label for="notes" class="form-label">Notes:</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="Notes"
          name="Notes"
          [(ngModel)]="WarrantyDetails.Notes"
          autocomplete="on"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-3" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn m-3">Update</button>
      </div>
      <div class="col-sm-4" style="text-align: left">
        <button
          type="button"
          class="btn custom-delete-btn m-3"
          (click)="deletewarranty(WarrantyDetails.Id)"
        >
          Delete
        </button>
      </div>
    </div>
  </form>
</div>
